/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object,
} from 'prop-types';
import { Query } from '@apollo/client/react/components';
import { gql } from '@apollo/client';
import mbpLogger from '@module-logger/mbp';
import { useSelector } from 'react-redux';
import { GRAPHQL_ENV } from '../../../gql';
import CustomerServiceBuilder from './CustomerServiceBuilder';
import CustomerServiceSkeleton from '../GraphqlSkeletonComponents/CustomerServiceSkeleton';
import { getBrand } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';

const CustomerServiceContainer = ({ page }) => {
    const brand = useSelector(getBrand);
    const CUSTOMER_SERVICE_QUERY = gql`
        query CustomerService {
            findContent(brand:"${brand['domain-name']}", environment:"${GRAPHQL_ENV}", contentType:"${page.contentType}"){
                content
            }
        }
    `;

    return (
        <Query query={CUSTOMER_SERVICE_QUERY}>
            {({ loading, error, data }) => {
                if (loading) {
                    return <CustomerServiceSkeleton />; // skeleton component
                }

                if (error) {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        query: CUSTOMER_SERVICE_QUERY,
                        component: 'CustomerService.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }

                if (!data) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: CUSTOMER_SERVICE_QUERY,
                        component: 'CustomerService.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                let customerServiceData = null;
                if (data?.findContent?.content !== null) {
                    if (data?.findContent?.content?.entries?.length > 0) {
                        customerServiceData = data?.findContent?.content?.entries?.[0];
                    }
                }
                return (
                    <>
                        {customerServiceData ? <CustomerServiceBuilder brand={brand} page={page} data={customerServiceData} /> : 'No data returned for query'}
                    </>
                );
            }}
        </Query>
    );
};

CustomerServiceContainer.propTypes = {
    page: object.isRequired,
};

export default CustomerServiceContainer;
